import {
  type OfferV11,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

export const productAccessorGetSellerPromotionFromOffer = (
  offer: OfferV11,
): SellerPromotionV2 | undefined => offer.sellerPromotionV2 ?? undefined
